module.exports = __webpack_public_path__ + "media/components/assets/icons/lesson_yet-5627cce5620fd655ee0a183964c7a422.svg";